import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { getServiceAccountingList } from "../store/api/Services";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { exportToExcel } from "../../store/api/CommonFunctions";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { ClipboardData, FileEarmarkExcelFill, LayerBackward, PrinterFill, Search } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getAllGuaranteeHolders } from "../store/api/GuaranteeApi";
import { getAllProductTypes } from "../store/api/GetAllProduct";

const ServiceAccountingReport = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { filterData, settings } = useSelector(state => { return { filterData: state.service.srvAccListFilters, settings: state.SystemSettingsReducer.systemSettings } });
    const { register, handleSubmit } = useForm();
    const [dateFilters, setDateFilters] = useState({});
    const [holders, setProductHolders] = useState([]);
    const [productTypes, setProductTypes] = useState([]);

    const [pending, setPending] = useState(false);
    const settingNames = ['ProductGrouppingType'];
    const pgType = Array.isArray(settings) && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "PServiceType", colTitle: "نوع سرویس", showInMobile: true },
        { colName: "InvoiceNumber", colTitle: "شماره سرویس", showInMobile: true },
        { colName: "ReceptionInAgent", colTitle: "پذیرش در نمایندگی", colType: "boolean" },
        { colName: "CustomerName", colTitle: "مشتری", showInMobile: true },
        { colName: "HolderName", colTitle: "مارک محصول", showCondition: () => pgType === 0 },
        { colName: "ProductName", colTitle: (pgType === 1 ? "نام محصول" : "نوع محصول"), showInMobile: true },
        { colName: "ProductModel", colTitle: "مدل محصول" },
        { colName: "ProductCode", colTitle: "کد محصول" },
        { colName: "ProductSerial", colTitle: "سریال محصول" },
        { colName: "IsGuarantee", colTitle: "گارانتی", colType: "boolean" },
        { colName: "UsedPartsGuaranteePrice", colTitle: "هزینه گارانتی قطعات", colType: "currency" },
        { colName: "UsedPartsCost", colTitle: "هزینه قطعات", colType: "currency" },
        { colName: "TotalGuaranteeServiceCost", colTitle: "اجرت گارانتی", colType: "currency" },
        { colName: "TotalServiceCost", colTitle: "اجرت", colType: "currency" },
        { colName: "Discount", colTitle: "تخفیف", colType: "currency" },
        { colName: "TaxAmount", colTitle: "مالیات", colType: "currency" },
        { colName: "ServiceIncome", colTitle: "درآمد سرویس", colType: "currency" },
        { colName: "AmountCustomerShouldPay", colTitle: "قابل پرداخت", colType: "currency" }
    ]
    function search(data) {
        const dateFrom = document.getElementsByName("DateFrom")[0].value;
        if (dateFrom !== "") {
            data.ContactDateFrom = dateFilters.DateFrom;
            data.PDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("DateTo")[0].value;
        if (dateTo !== "") {
            data.ContactDateTo = dateFilters.DateTo;
            data.PDateTo = dateTo;
        }
        const refDateFrom = document.getElementsByName("LastRefDateFrom")[0].value;
        if (refDateFrom !== "") {
            data.LastRefDateFrom = dateFilters.LastRefDateFrom;
            data.PRefDateFrom = refDateFrom;
        }
        const refDateTo = document.getElementsByName("LastRefDateTo")[0].value;
        if (refDateTo !== "") {
            data.LastRefDateTo = dateFilters.LastRefDateTo;
            data.PRefDateTo = refDateTo;
        }
        const archiveDateFrom = document.getElementsByName("ArchiveDateFrom")[0].value;
        if (archiveDateFrom !== "") {
            data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
            data.PArchiveDateFrom = archiveDateFrom;
        }
        const archiveDateTo = document.getElementsByName("ArchiveDateTo")[0].value;
        if (archiveDateTo !== "") {
            data.ArchiveDateTo = dateFilters.ArchiveDateTo;
            data.PArchiveDateTo = archiveDateTo;
        }         
        data.Skip = 0;
        dispatch(getServiceAccountingList(data));

    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetServiceAccountingList`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("ServiceAccountingList", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/ServiceAccountingList/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetServiceAccountingList`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    useEffect(() => {
        document.body.classList="notMain";
        dispatch(getSystemSettings(settingNames));
        
        document.title = "بی همتا-خدمات";
        getAllGuaranteeHolders("", setProductHolders);
        getAllProductTypes(setProductTypes);
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCalculator} size="lg" />&nbsp;
                    گزارش ریالی سرویس ها
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder" style={{fontSize:"11px"}}>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش از: </label>
                                <DatePicker className="search-input" timePicker={false} isGregorian={false} name="DateFrom" value={dateFilters?.DateFrom ? momentJalaali(dateFilters.DateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, DateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش تا: </label>
                                <DatePicker className="search-input" timePicker={false} isGregorian={false} name="DateTo" value={dateFilters?.DateTo ? momentJalaali(dateFilters.DateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, DateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ انجام از: </label>
                                <DatePicker className="search-input" timePicker={false} isGregorian={false} name="LastRefDateFrom" value={dateFilters?.LastRefDateFrom ? momentJalaali(dateFilters.LastRefDateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, LastRefDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ انجام تا: </label>
                                <DatePicker className="search-input" timePicker={false} isGregorian={false} name="LastRefDateTo" value={dateFilters?.LastRefDateTo ? momentJalaali(dateFilters.LastRefDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, LastRefDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ بایگانی از: </label>
                                <DatePicker className="search-input" timePicker={false} isGregorian={false} name="ArchiveDateFrom" value={dateFilters?.ArchiveDateFrom ? momentJalaali(dateFilters.ArchiveDateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ArchiveDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ بایگانی تا: </label>
                                <DatePicker className="search-input" timePicker={false} isGregorian={false} name="ArchiveDateTo" value={dateFilters?.ArchiveDateTo ? momentJalaali(dateFilters.ArchiveDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ArchiveDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>                               
                            <Col md={2} className="form-group">
                                <label>نوع سرویس</label>
                                <select className="search-input" name="ServiceType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="repair">تعمیر</option>
                                    <option value="install">نصب</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مشخصات مشتری: </label>
                                <input className="search-input"name="CustomerName" ref={register({})} />
                            </Col>
                            {
                                pgType === 1 ?
                                    <Col md={2} className="form-group">
                                        <label>نام محصول:</label>
                                        <input className="search-input"name="ProductName" ref={register({})} />
                                    </Col> :
                                    <Fragment>
                                        <Col md={2} className="form-group">
                                            <label>مارک محصول:</label>
                                            <select className="search-input" name="ProductHolder" ref={register({})} defaultValue={filterData?.HolderName ?? ""}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(holders) && holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                                            </select>
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نوع محصول:</label>
                                            {productTypes === "PENDING" ?
                                                <div className="search-input" style={{ textAlign: "center" }}>
                                                    <Loader type="BallTriangle" color="#bb1370" height={25} width={25} />
                                                </div> :
                                                <select className="search-input" name="ProductType" ref={register({})} defaultValue={filterData?.ProductType ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {Array.isArray(productTypes) && productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                    </Fragment>
                            }
                            <Col md={2} className="form-group">
                                <label>مدل محصول:</label>
                                <input className="search-input"name="ProductModel" ref={register({})} defaultValue={filterData?.ProductModel ?? ""} />
                            </Col>
                           <Col md={2} className="form-group">
                                <label>سریال محصول:</label>
                                <input className="search-input"name="ProductSerial" ref={register({})} defaultValue={filterData?.ProductSerial ?? ""} />
                            </Col>                            
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه: </label>
                                <select className="search-input" name="Take" ref={register({})}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </Col>
                        </Row>
                        <Button type="submit" className="mt-1 group-Btn-large"><ClipboardData size={18} />&nbsp; خروجی گزارش </Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} reducerName="service" searchMethod={(data) => dispatch(getServiceAccountingList(data))} objectName="srvAccList" filterData={filterData} hasPaging style={{ whiteSpace: "nowrap" }} />
                </Card.Body>
            </Card>
        </div>)
}
export default ServiceAccountingReport;